/**
 *
 * @module mediaLauncher
 * @description Create and launch game media links
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('mediaLauncher/mediaLauncher',['jquery', 'deep-equal/index', 'client/client', 'pageMeta/pageMeta', 'bam.cookies/cookies'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'), require('deep-equal/index'), require('client/client'), require('pageMeta/pageMeta'), require('bam.cookies/cookies'));
    } else {
        root.bamMediaLauncher = factory(root.jQuery, root.deepEqual, root.bamClient, root.bamPageMeta, root.bamCookies);
    }

}(this, function($, deepEqual, client, pageMeta, cookies) {

    'use strict';

    /* TVMPFIVE-737 */
    var $html                  = $('html');
    var mpfiveSupportedBrowser = (!$html.hasClass('ie9') && !$html.hasClass('lt-ie9')); // IE10+
    var mpfiveBetaCookie       = cookies.get('mpfiveBetaCookie');
    var mpfiveAccess           = (mpfiveBetaCookie === 'true' || mpfiveBetaCookie === true); // mpfiveBetaCookie = true
    var useMP5                 = true; //(mpfiveSupportedBrowser && mpfiveAccess);
    var exports                = {};

    var alreadyCreated = [];
    var defaultParams = {
        source: 'MLB',
        sponsor: 'MLB',
        clickOrigin: 'MSB',
        affiliateId: 'MSB',
        team: 'mlb'
    };

    function createUrl( params ) {
        var url = '/shared/flash/mediaplayer/MP4.jsp?';
        var paramArray = [];
        $.each(params, function( key, val ) {
            paramArray.push( key+'='+val );
        });
        url += paramArray.join('&');

        return url;
    }

    function getMediaPlayerUrl( params ) {

        params = $.extend({}, defaultParams, params);

        /* TVMPFIVE-737 */
        if (useMP5) {

            var mobileUrl = pageMeta.mobile_url || 'http://m.mlb.com',
            mp5Url  = mobileUrl + '/tv/';
            if (params.calendar_event_id) {
                mp5Url += 'e' + params.calendar_event_id + '/';
            }
            if (params.content_id) {
                mp5Url += 'v' + params.content_id + '/';
            }

            // Grab params to pass along to MP5
            var mp5UrlParams = [];

            if ( params.media_type && (params.media_type === 'audio') ) {
                mp5UrlParams.push('media_type=' + params.media_type);
            }
            if ( params.clickOrigin ) {
                mp5UrlParams.push('clickOrigin=' + params.clickOrigin);
            }
            if ( params.team ) {
                mp5UrlParams.push('team=' + params.team);
            }

            if ( params.debug ) {
                mp5UrlParams.push('&debug=' + params.debug);
            }
            if ( params.environment ) {
                mp5UrlParams.push('env=' + params.environment);
            }

            // Construct full MP5 URL
            if ( mp5UrlParams.length > 0 ) {
                mp5Url += '?' + mp5UrlParams.join('&');
            }

            return mp5Url;
        } else {
            var url = createUrl( params );
            return url;
        }
    }

    exports.launchWithParams = function( params ) {
        var url = getMediaPlayerUrl( params );

        if (useMP5) {
            window.location = url;
        } else {
            var height = 660;
            if (client.isChrome && client.isMacOS) {
                height += 30;
            }

            window.open(url, 'mp4', 'height='+height+',width=960,resizable=0');
        }


    };

    exports.getUrl = function( params, game ) {

        if (!client.isDesktop) {
            return 'http://m.mlb.com/game/'+game.gameday;
        }

        var url = getMediaPlayerUrl(params);

        if (!useMP5) {
            var paramsAlreadyUsed = alreadyCreated.filter(function( previousData ) { return deepEqual( previousData.params, params ); });
            if (paramsAlreadyUsed[0]) {
                return paramsAlreadyUsed[0].url;
            }

            $(document.body).on('click', 'a[href$="'+url+'"]', function( event ) {
                event.preventDefault();

                exports.launchWithParams( params );
            });

            alreadyCreated.push({
                params: params,
                url: url
            });
        }

        return url;

    };

    exports.getUrlFromLegacyString = function( str, game ) {
        var firstParen = str.indexOf('(');
        if (firstParen !== -1) {
            str = str.substr(firstParen);
        }
        var params = eval(str);

        return exports.getUrl( params, game );
    };

    return exports;

}));

